import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router'
import { DeviceDetectorService } from 'ngx-device-detector';
import { HttpClient } from "@angular/common/http";
import { UserService } from 'app/services/user/user.service';
import { Web3Service } from 'app/services/web3/web3.service';
import { ContractsService } from 'app/services/contract/contracts.service';
import { eContracts } from 'app/services/contract/contract.config';
import { environment } from 'environments/environment';
declare const window
declare const analytics
@Component({
  selector: 'app-play',
  templateUrl: './play.component.html',
  styleUrls: ['./play.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PlayComponent implements OnInit {

  // public account
  public hasKryptomonV2
  public hasKryptomonV1
  public isMobile
  public noKryptomons
  wallet: string
  web3: any;

  constructor(
    private http: HttpClient,
    private deviceSrv: DeviceDetectorService,
    private router: Router,
    private userService: UserService,
    private web3Service: Web3Service,
    private contractsService: ContractsService
  ) {

    this.wallet = this.userService._userInfoData.recordedWallet;
    this.web3 = this.web3Service.getWeb3();
    //this.hasKryptomonV1 = true;
    //this.hasKryptomonV2 = true;
    this.isMobile = false;

    // if (this.appComponent.accounts == undefined) {
    //   this.appComponent.accountsObservable.subscribe((item: any) => {
    //     this.account = item[0];
    //     if (this.account !== undefined && this.account !== "") {
    //       this.getKryptomons();
    //     }
    //   });
    // } else {
    //   this.account = this.appComponent.accounts[0];
    //   this.getKryptomons();
    // }

    this.getKryptomons();

    if (this.deviceSrv.isMobile() || this.deviceSrv.isTablet()) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    console.log(this.isMobile)

  }

  async getKryptomons() {
    //this.isLoading = true;
    console.log('getKryptomons')
    this.contractsService.getContract( eContracts.KMONFT).methods
      .ownedKryptomons()
      .call({
        from: this.wallet,
      })
      .then((receipt) => {
        console.log(receipt);
        if (receipt.length > 0) {
          this.hasKryptomonV1 = true;
        } else {
          this.hasKryptomonV1 = false;
        }
        this.contractsService.getContract( eContracts.KMONFTV2).methods
          .ownedKryptomons()
          .call({
            from: this.wallet,
          })
          .then((receipt) => {
            console.log(receipt);
            if (receipt.length > 0) {
              this.hasKryptomonV2 = true;
            } else {
              this.checkApi();
            }

          }).catch((err) => {
            console.log(err, 'err')
          });
      })
      .catch((err) => {
        console.log(err, 'err');
      });

  }

  checkApi() {
    this.http.get(environment.apiBaseUrlV22 + "user/" + this.wallet + "/kryptomons/detail?offset=0&limit=1000").subscribe(async (response: any) => {
      if (response.length < 1) {
        this.hasKryptomonV2 = false;
      } else {
        this.hasKryptomonV2 = true;
      }
    })
  }

  ngOnInit(): void {
  }

  goToWizard() {
    this.router.navigate(['/marketplace'])
  }
  goToKryptomons() {
    this.router.navigate(['/kryptomons'])
  }
  playAndroid() {
    window.open("https://play.google.com/store/apps/details?id=com.KryptomonCompany.Kryptomon", '_blank').focus();
    analytics.track('Download Genesis', {
      section: 'play',
      value: 'android',
    });
  }

  playiOs() {
    window.open("https://testflight.apple.com/join/CkBY8AAq", '_blank').focus();
    analytics.track('Download Genesis', {
      section: 'play',
      value: 'ios',
    });
  }

}
